import { render } from "./CatalogModal.vue?vue&type=template&id=34989c0c&scoped=true"
import script from "./CatalogModal.vue?vue&type=script&lang=js"
export * from "./CatalogModal.vue?vue&type=script&lang=js"

import "./CatalogModal.vue?vue&type=style&index=0&id=34989c0c&lang=scss&scoped=true"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34989c0c"]])

export default __exports__